export default __webpack_public_path__ + "static/media/cue.9e188f05.jpg";